export function permittedUrl(value: string, base?: string): URL {
  const url = new URL(value, base);
  const local = ["localhost", "127.0.0.1", "[::1]"].includes(url.hostname);
  if (url.username || url.password || (url.protocol !== "https:" && !(local && url.protocol === "http:"))) {
    throw new Error("This address is not allowed.");
  }
  return url;
}

export function resolveRedirect(candidate: string | null, fallback: string, origins: string[], currentOrigin: string): string {
  const url = permittedUrl(candidate || fallback, currentOrigin);
  const allowed = origins.map((entry) => {
    const origin = permittedUrl(entry.trim());
    if (origin.pathname !== "/" || origin.search || origin.hash) throw new Error("Redirect origins must contain only an origin.");
    return origin.origin;
  });
  if (!allowed.includes(url.origin) || url.hash) throw new Error("This return address is not allowed.");
  const sensitive = /^(?:token|access_token|id_token|refresh_token|authorization|user_?id|clerk_?id|session_?id)$/i;
  url.searchParams.forEach((_value, name) => {
    if (sensitive.test(name)) throw new Error("Return addresses cannot contain account credentials.");
  });
  return url.href;
}

export function apiEndpoint(base: string | undefined, path: string): string {
  if (!base) throw new Error("The account service is not configured.");
  const url = permittedUrl(base);
  if (url.search || url.hash) throw new Error("Invalid account service address.");
  return new URL(path, url.href.replace(/\/?$/, "/")).href;
}
